module.exports = __webpack_public_path__ + "static/img/WechatIMG40.01f663f4.jpeg";